module.exports = __webpack_public_path__ + "static/img/jifan.af9bbf0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/industryApplication/tab2/jifan.png
// module id = UmIS
// module chunks = 0